export default "__VITE_ASSET__8VyPVV5e__"